import React from 'react';
import flow from 'lodash/flow';
import Button from '@atlaskit/button/standard-button';
import withFireUiAnalytics from '@atlassian/jira-analytics-web-react/src/components/with-fire-ui-analytics.tsx';
import { injectIntl, type IntlShape } from '@atlassian/jira-intl';
import { Link } from '@atlassian/react-resource-router';
import messages from './messages.tsx';

export type CreateButtonProps = {
	onClick?: () => void;
};

type Props = CreateButtonProps & {
	intl: IntlShape;
};

export const CreateButton = ({ onClick, intl: { formatMessage } }: Props): React.JSX.Element => (
	<Button
		href={`/issues/?jql=${encodeURIComponent('created >= -30d order by created DESC')}`}
		onClick={onClick}
		appearance="primary"
		// @ts-expect-error - TS2322 - Type '{ children: string; href: string; onClick: (() => void) | undefined; appearance: "primary"; externalId: string; }' is not assignable to type 'IntrinsicAttributes & ButtonProps & RefAttributes<HTMLElement>'.
		externalId="directory.filters-v2.create-button"
		component={Link}
	>
		{formatMessage(messages.createFilter)}
	</Button>
);

export default flow(withFireUiAnalytics({ onClick: 'createFilter' }), injectIntl)(CreateButton);
